module.exports = __webpack_public_path__ + "static/img/03.60cde60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/140219/03.png
// module id = Y38A
// module chunks = 0